export default __webpack_public_path__ + "static/media/v003.6d01154a.mp4";